import React from 'react';
import '../Shared/Troubleshooting.css'

const Troubleshooting = () => {
    return (
        <div className='troubleshooting-tips'>
            <h1 className="page-title">Trouble Shooting Guide</h1>
            <p>The following are helpful tips to diagnosing issues that might occur while the API is running.</p>
            <hr />
            <h2>WORKFORCEIDNUM cannot be null</h2>
            <p>This error generally occurs because of a timing issue with the processes that populate OCIO.</p>
            <b>Resolution Steps</b>
            <ul>
                <li>Generally this error will resolve on its own after a few more runs of the API, but if it doesn't a force sync might be required from someone on the OCIO team.</li>
            </ul>
            <hr />
            <h2>Multiple matrix id's found in the xref table for ******</h2>
            <p>This can happen for a couple of reasons, but generally it means that there are two profiles in Matrix, or at least a credential has already been created using someone else's Buck ID</p>
            <b>Resolution Steps</b>
            <ul>
                <li>Use the <a href='/Users'>User Compare</a> tool, to see if there are indeed two profiles for the person in question</li>
                <li>If ther are two profiles, find the one that has a credential equal to the user's Buck ID</li>
                <li>Use the <a href='/XrefData'>Xref Data</a> tool, to delete the record tied to the Buck ID, and ensure that there is a record that ties the WORKFORCEIDNUM to the PersonID of the non-Buck ID record</li>
                <li>Request that the duplicate record is purged by security in Matrix</li>
                <li>Add the record back to the <a href='/Staging'>Staging Table</a> to be processed again. This should update the original profile, creating a new credential based on their Buck ID, instead of adding a new record.</li>
            </ul>
            <ul>
                <li>If there are NOT two profiles. You will need to work with someone from security to find the credential associated with the Buck ID in Matrix. Then determine the correct steps needed to resolve the issue</li>
            </ul>
            <hr />
            <h2>Credentialing Error for ******: CredentialNum is not unique.</h2>
            <p>This can happen if there was a syncing issue with the job that populates the xref table and the API, OR a person's WORKFORCEIDNUM changed between API runs </p>
            <b>Resolution Steps</b>
            <ul>
                <li>User the <a href='/UserUpdates'>User Updates</a> tool to look up all the updates for the user in question.</li>
                <li>Check to see if their WORKFORCEIDNUM has changed</li>
                <li>If it has changed use the <a href='/XrefData'>Xref Data</a> tool to delete the record with the old WORKFORCEIDNUM</li>
                <li>Make sure the new WORKFORCEIDNUM is linked to the correct Person ID in Matrix</li>
            </ul>
            <ul>
                <li>If the WORKFORCEIDNUM has not changed then use the <a href='/XrefData'>Xref Data</a> tool to find the duplicate records.</li>
                <li>Use the <a href='/Users'>User Compare</a> tool to validate which record looks correct</li>
                <li>Request that the incorrect record is purged by security in Matrix</li>
                <li>Make sure the User 16 field is populated with the correct WORKFORCEIDNUM. If it is not, request someone from IDM update Matrix with the correct value</li>
            </ul>
            <hr />
            <h2>OSUbuckID Must Be 10 or 16 Digits</h2>
            <p>
                This error may occur when the OSUbuckID value is missing, invalid, or has not synchronized correctly. It is most commonly caused by a synchronization issue or when a display badge is created for an individual who does not have a valid BuckID assigned.
            </p>
            <b>Resolution Steps</b>
            <ul>
                <li>Contact the OCIO team to verify the user's identity data and perform a force sync using the Sync button on the <a href='/Users'>User Compare</a> tool if necessary.</li>
                <li>Contact the BuckID team to confirm that the OSUbuckID is valid and that the correct identifier is assigned to the individual.</li>
                <li>After any updates or synchronization activities are completed, verify that the OSUbuckID is populated with the correct 16-digit value.</li>
            </ul>
        </div>
    );
};

export default Troubleshooting;